import React from 'react';

import '@builder.io/widgets';
import { builder, BuilderComponent } from '@builder.io/react';
import { BUILDER_API_KEY } from '../../../../utils/environment';
import { SHOP_LOCALE } from 'src/scripts/utils/constants';

// Init builder
if (BUILDER_API_KEY && !builder.apiKey) builder.init(BUILDER_API_KEY);

const PdpBuilderContent = ({
  targetingAttributes,
  model,
  contentEntryId,
}: {
  targetingAttributes?: {
    styleId: string | undefined;
    productTags: string[];
  };
  contentEntryId?: string;
  model: string;
}) => {
  let builderContent;
  if (BUILDER_API_KEY) {
    if (targetingAttributes && !contentEntryId) builder.setUserAttributes(targetingAttributes);
    builderContent = <BuilderComponent model={model} entry={contentEntryId} locale={SHOP_LOCALE} />;
  }
  return <>{builderContent ?? null}</>;
};

export default PdpBuilderContent;
